exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".course-empty-state---1B9wE {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 50vh; }\n  .course-empty-state---1B9wE .header---o-oqP {\n    font-size: 25px;\n    font-weight: bold; }\n  .course-empty-state---1B9wE .content---TuAy_ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 18px;\n    margin-top: 16px; }\n  .course-empty-state---1B9wE .content---TuAy_ button {\n      background-color: transparent;\n      border: 0;\n      text-decoration: underline;\n      color: #278bcb; }\n", ""]);

// exports
exports.locals = {
	"course-empty-state": "course-empty-state---1B9wE",
	"header": "header---o-oqP",
	"content": "content---TuAy_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/skill-quests-mastery/student/components/course-empty-state/course-empty-state.scss
// module id = nYQu
// module chunks = 1